module.exports = {
  familyName: 'Lato',
  capHeight: 1433,
  ascent: 1974,
  descent: -426,
  lineGap: 0,
  unitsPerEm: 2000,
  xHeight: 1013
};
